import React, { useState, useEffect, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMessage } from '../../context/message';
import { useAuth } from "../../context/auth";
import { useChat } from '../../context/chat'
import { useField } from '../../context/context'
import MaterialTable from 'material-table';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import InquiryBidForm from './InquiryBidForm';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AccessModeTable from '../display/AccessModeTable';
import CustomFilter from '../CustomFilter';
import { rangeFilter, dateRangeFilter } from '../FilterFunctions';
import Typography from '@material-ui/core/Typography'
import AlertDialog from '../inputs/AlertDialog'
import RefreshIcon from '@material-ui/icons/Refresh';
import Tooltip from '@material-ui/core/Tooltip';
//import AttachFileIcon from '@material-ui/icons/AttachFile'
import BidFileSelect from '../inputs/BidFileSelect'
import CircularProgress from '@material-ui/core/CircularProgress'
import FAQ from '../display/FAQ'
import HelpIcon from '@material-ui/icons/Help'
import MessageIcon from '@material-ui/icons/Message'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import InfoIcon from '@material-ui/icons/Info'
import InfoDialog from '../display/InfoDialog'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import ReviewedFilter from '../display/ReviewedFilter';
import ExportMaterialTable from '../display/ExportMaterialTable'
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  place_bid: {
    marginLeft: 5,
    marginTop: 5,
    display: 'flex',
    'flex-direction': 'row',
  },
  attach: {
    height: 30,
    width: 30,
    top: -5,
    left: 5
  },
  chip: {
    bottom: 20,
    left: 20
  },
  loading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -16,
    marginLeft: -16
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  reviewToggleWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  reviewToggleGroup: {
    borderRadius: 20,
    overflow: 'hidden',
  },
  reviewToggleButton: {
    textTransform: 'none',
    padding: '2px 10px',
    fontSize: '0.75rem',
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.black,
    },
  },
}));

export default function AllInquiriesTable() {
  const { setMessage } = useMessage();
  const classes = useStyles()
  const { auth } = useAuth();
  const userId = sessionStorage.getItem('user_id');
  const teamId = Number(sessionStorage.getItem('team_id'));
  const isTeamUser = Number.isFinite(teamId) && teamId > 0;
  const [reviewedFilterValue, setReviewedFilterValue] = useState(['reviewed', 'unreviewed']);
  const [reviewInfoOpen, setReviewInfoOpen] = useState(false);
  const [reviewInfo, setReviewInfo] = useState({
    reviewed_by: null,
    reviewed_by_username: null,
    reviewed_date: null,
  });
  const [selectedInquiryId, setSelectedInquiryId] = useState(null); //for reviewed dialog
  const { openConversations, setOpenConversations, setChatroom, setCurrentChat, anchorRef } = useChat()
  const { products, regions, fetchFields, setFetchFields } = useField()
  const [data, setData] = useState([]);
  const [bounds, setBounds] = useState({});
  const [toggle, fetchData] = useState(false);
  const [open, setOpen] = useState(false);
  const [openFAQ, setOpenFAQ] = useState(false)
  const [openInfo, setOpenInfo] = useState(false)
  const [product_lookup, setProduct_lookup] = useState({});
  const [region_lookup, setRegion_lookup] = useState({})
  const [inquire, setInquire] = useState(false)
  const [inquiryId, setInquiryId] = useState()
  const [loading, setLoading] = useState(false)
  const [bid, setBid] = useState({
    inquiry_id: '',
    storage_id: '',
    volume: '',
    ask_price: '',
    term: '',
    date_available: new Date(),
    comment: '',
    file: '',
    name: '',
    allow_sublet: ''
  });
  //file select
  // const [bidAttach, setBidAttach] = useState(false)
  // const [byteArrays, setByteArrays] = useState([])
  // const [previewURLs, setPreviewURLs] = useState([])
  // const [fileNames, setFileNames] = useState([])
  // const [bidToggle, setBidToggle] = useState(false)

  const tableRef = React.useRef();
  const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [columnOrder, setColumnOrder] = useState([]);

  const handleClose = () => {
    setOpen(false);
    // setFileNames([])
    // setPreviewURLs([])
    // setByteArrays([])
    fetchData(!toggle);
  };

  const updateField = e => {
    setBid({
      ...bid,
      [e.target.name]: e.target.value
    });
  };

  const closeInquire = () => {
    setInquire(false)
  }

  const handleCloseInfo = () => {
    setOpenInfo(false)
  }

  const submitInquiry = () => {
    fetch(`/api/message/inquire/inquiry/${inquiryId}`, {
      method: 'POST',
      headers: {
        'x-access-token': sessionStorage.getItem('token')
      },
    })
      .then(response => auth(response))
      .then(response => {
        if (response.message.type === 'success') {
          let message = response.data
          message['last_read'] = 0
          anchorRef.current[message.conversation_id] = React.createRef()
          openConversations.push(message)
          setOpenConversations([...openConversations])
          setCurrentChat(message)
          setChatroom(true)
        }
        else (
          setMessage(response.message)
        )
      })
      .catch((error) => {
        setMessage({ 'type': 'error', 'text': 'Error! Unable to start inquiry.' })
        console.error('Error:', error);
      })
    closeInquire()
  }

  // const attach = () => {
  //   setBid({
  //     ...bid,
  //     'name': fileNames,
  //     'file': byteArrays,
  //   })
  // }

  const handleSubmit = () => {
    if (!loading) {
      setLoading(true)
      fetch(`/api/inquiry_bids/${bid.inquiry_id}`, {
        method: 'POST',
        headers: {
          'x-access-token': sessionStorage.getItem('token'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(bid)
      })
        .then(response => auth(response))
        .then(response => {
          if (response.message.type === 'success') {
            handleClose();
          }
          setMessage(response.message);
          setLoading(false)
        })
        .catch(error => {
          setMessage({ type: 'error', text: 'Error! Unable to submit bid' });
          setLoading(false)
          console.error('Error:', error);
        })
    }
  };

  useEffect(() => {
    fetch('/api/inquiry/all', {
      method: 'GET',
      headers: {
        'x-access-token': sessionStorage.getItem('token')
      }
    })
      .then(response => auth(response))
      .then(response => {
        setData(response.data || []);
        setBounds(response.bounds || {});
      })
      .catch(error => {
        setMessage({ type: 'error', text: 'Error! Unable to fetch data' });
        console.error('Error:', error);
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setMessage, toggle]);

  useEffect(() => {
    if (products) {
      let temp = {};
      products.map(item => temp[item.product] = item.product);
      setProduct_lookup(temp)
    } else {
      setFetchFields(!fetchFields)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products])

  useEffect(() => {
    if (regions) {
      let temp = {}
      regions.map(item => temp[item.region] = item.region)
      setRegion_lookup(temp)
    } else {
      setFetchFields(!fetchFields)
    }
  }, [regions])

  const reviewedColumnRef = React.useRef(null);

  if (!reviewedColumnRef.current) {
    reviewedColumnRef.current = {
      title: 'Reviewed',
      field: 'reviewed',
      sorting: false,
      // we will attach filterComponent below (needs current state)
      filterComponent: null,

      customFilterAndSearch: (term, rowData) => {
        const isReviewed = !!rowData.reviewed;

        if (!term || term.length === 2) return true;
        if (term.includes('reviewed') && isReviewed) return true;
        if (term.includes('unreviewed') && !isReviewed) return true;

        return false;
      },

    };
  }

  reviewedColumnRef.current.filterComponent = (props) => (
    <ReviewedFilter
      value={reviewedFilterValue}
      onChange={(newValue) => {
        setReviewedFilterValue(newValue);

        // update material-table filter value
        if (newValue === 'all') {
          props.onFilterChanged(props.columnDef.tableData.id, undefined);
        } else {
          props.onFilterChanged(props.columnDef.tableData.id, newValue);
        }
      }}
    />
  );

  reviewedColumnRef.current.render = (rowData) => (
    <Tooltip
      title={
        rowData.reviewed
          ? 'Reviewed – click for details'
          : 'Click to mark as reviewed'
      }
    >
      <IconButton
        color="primary"
        onClick={(e) => {
          e.stopPropagation();
          handleReviewIndicatorClick(rowData);
        }}
      >
        {rowData.reviewed ? (
          <CheckCircleIcon fontSize="small" />
        ) : (
          <RadioButtonUncheckedIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );


  const baseColumns = [
    {
      title: 'Inquiry ID',
      field: 'inquiry_id'
    },
    {
      title: 'Region',
      field: 'region',
      lookup: region_lookup
    },
    {
      title: 'Location',
      field: 'formatted_address',
    },
    {
      title: 'Radius',
      field: 'radius',
      bounds: bounds.radius,
      customFilterAndSearch: rangeFilter('radius')
    },
    {
      title: 'Product',
      field: 'product',
      lookup: product_lookup,
    },
    {
      title: 'Volume Range(MBBL)',
      field: 'volume_range',
      type: 'numeric',
      bounds: bounds.min_volume ? [bounds.min_volume[0], bounds.max_volume[1]] : [0, 1],
      customFilterAndSearch: (term, rowData) => (term[0] <= rowData.max_volume) && (term[1] >= rowData.min_volume),
    },
    {
      title: 'Price (USD/BBL)',
      field: 'bid_price',
      type: 'numeric',
      step: .1,
      bounds: bounds.bid_price,
      customFilterAndSearch: rangeFilter('bid_price')
    },
    {
      title: 'Start Date',
      field: 'start_date',
      type: 'date',
      customFilterAndSearch: dateRangeFilter('start_date'),
      customSort: (a, b) => {
        var date1 = new Date(a.start_date)
        var date2 = new Date(b.start_date)

        return date1 - date2
      },
      render: rowData => <p>{(new Date(rowData.start_date)).toLocaleDateString()}</p>
    },
    {
      title: 'Term (Months)',
      field: 'term',
      type: 'numeric',
      bounds: bounds.term,
      customFilterAndSearch: rangeFilter('term')
    },
    {
      title: 'Date Requested',
      field: 'date_placed',
      type: 'date',
      customFilterAndSearch: dateRangeFilter('date_placed'),
      render: rowData => <p>{(new Date(rowData.date_placed)).toLocaleDateString()}</p>
    },
    {
      title: 'Comment',
      field: 'comment',
      render: rowData => (
        rowData.comment && (rowData.comment.length > 30 ? rowData.comment.substring(0, 30) + '...' : rowData.comment)
      )
    }
  ];

  const columnSource = isTeamUser
    ? [reviewedColumnRef.current, ...baseColumns]
    : baseColumns;

  const orderedColumnSource = columnOrder.length > 0
    ? [
        ...columnOrder
          .map((field) => columnSource.find((column) => column.field === field))
          .filter(Boolean),
        ...columnSource.filter((column) => !columnOrder.includes(column.field)),
      ]
    : columnSource;

  const baseDisplayColumns = orderedColumnSource.map((column) => ({
    ...column,
    rawTitle: column.title,
    hidden: hiddenColumns.includes(column.field),
  }));

  const hideColumn = (column) => {
    setHiddenColumns((prev) => (
      prev.includes(column.field) ? prev : [...prev, column.field]
    ));
  };

  const columns = baseDisplayColumns.map((column) => ({
    ...column,
    title: (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        <span>{column.rawTitle}</span>
        <IconButton
          size="small"
          color="primary"
          onClick={(event) => {
            event.stopPropagation();
            hideColumn(column);
          }}
          style={{ padding: 2 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </span>
    ),
  }));

  const setAllColumnsVisible = () => {
    setHiddenColumns([]);
  };

  const setAllColumnsHidden = () => {
    setHiddenColumns(columnSource.map((column) => column.field).filter(Boolean));
  };

  const toggleColumn = (column) => {
    setHiddenColumns((prev) => (
      prev.includes(column.field)
        ? prev.filter((field) => field !== column.field)
        : [...prev, column.field]
    ));
  };

  const closeColumnMenu = () => {
    setColumnMenuAnchor(null);
  };

  const moveColumn = (items, sourceIndex, destinationIndex) => {
    const nextItems = [...items];
    const [movedItem] = nextItems.splice(sourceIndex, 1);
    nextItems.splice(destinationIndex, 0, movedItem);
    return nextItems;
  };

  const handleColumnDragged = (sourceIndex, destinationIndex) => {
    const visibleColumns = baseDisplayColumns.filter((column) => !column.hidden);
    const sourceColumn = visibleColumns[sourceIndex];
    const destinationColumn = visibleColumns[destinationIndex];

    if (!sourceColumn || !destinationColumn) return;

    const currentOrder = columnOrder.length > 0
      ? columnOrder
      : columnSource.map((column) => column.field);
    const sourceOrderIndex = currentOrder.indexOf(sourceColumn.field);
    const destinationOrderIndex = currentOrder.indexOf(destinationColumn.field);

    if (sourceOrderIndex === -1 || destinationOrderIndex === -1) return;

    setColumnOrder(moveColumn(currentOrder, sourceOrderIndex, destinationOrderIndex));
  };


  const accessModes = (rowData) => {
    return (
      <AccessModeTable inquiry_id={rowData.inquiry_id} />
    )
  }

  // const chipDelete = (index) => {
  //   fileNames.splice(index,1)
  //   byteArrays.splice(index,1)
  //   previewURLs.splice(index,1)
  //   setBidToggle(!bidToggle)
  // }

  const handleMarkReviewed = (row) => {
    fetch(`/api/inquiry/${row.inquiry_id}/review`, {
      method: 'POST',
      headers: {
        'x-access-token': sessionStorage.getItem('token'),
      },
    })
      .then(response => auth(response))
      .then(response => {
        if (response.message) {
          setMessage(response.message);
        }
        if (response.message?.type === 'success') {
          fetchData(prev => !prev);
        }
      })
      .catch(error => {
        console.error('Error marking inquiry as reviewed:', error);
        setMessage({ type: 'error', text: 'Error marking inquiry as reviewed.' });
      });
  };

  const handleReviewIndicatorClick = (row) => {
    if (!row.reviewed) {
      handleMarkReviewed(row);
    } else {
      setSelectedInquiryId(row.inquiry_id);
      setReviewInfo({
        reviewed_by: row.reviewed_by,
        reviewed_by_username: row.username,
        reviewed_date: row.reviewed_date,
      });
      setReviewInfoOpen(true);
    }
  };

  const handleRemoveReviewed = () => {
    if (!selectedInquiryId) return;

    fetch(`/api/inquiry/${selectedInquiryId}/review`, {
      method: 'DELETE',
      headers: {
        'x-access-token': sessionStorage.getItem('token'),
      },
    })
      .then((response) => auth(response))
      .then((response) => {
        if (response.message) setMessage(response.message);

        if (response.message?.type === 'success') {
          setReviewInfoOpen(false);
          setSelectedInquiryId(null);
          fetchData((prev) => !prev);
        }
      })
      .catch((error) => {
        console.error('Error removing review:', error);
        setMessage({ type: 'error', text: 'Error removing review.' });
      });
  };



  return (
    <div>
      <Menu
        anchorEl={columnMenuAnchor}
        open={Boolean(columnMenuAnchor)}
        onClose={closeColumnMenu}
      >
        <MenuItem
          key="column-list-title"
          disabled
          style={{ opacity: 1, fontWeight: 600, fontSize: 12 }}
        >
          Add or remove columns
        </MenuItem>
        <MenuItem
          key="select-all-columns"
          onClick={setAllColumnsVisible}
        >
          <Typography color="primary">Select All</Typography>
        </MenuItem>
        <MenuItem
          key="deselect-all-columns"
          onClick={setAllColumnsHidden}
        >
          <Typography color="primary">Deselect All</Typography>
        </MenuItem>
        <Divider />
        {columns.map((column) => (
          <MenuItem
            key={column.field}
            onClick={() => toggleColumn(column)}
          >
            <Checkbox
              color="primary"
              checked={!column.hidden}
              readOnly
              style={{ pointerEvents: 'none' }}
            />
            <span>{column.rawTitle}</span>
          </MenuItem>
        ))}
      </Menu>
      <Dialog
        open={reviewInfoOpen}
        onClose={() => setReviewInfoOpen(false)}
      >
        <DialogContent>
          <Typography variant="subtitle1">
            Reviewed by:{' '}
            {reviewInfo.reviewed_by_username || 'Unknown'}
          </Typography>
          <Typography variant="subtitle1">
            Reviewed at:{' '}
            {reviewInfo.reviewed_date
              ? new Date(reviewInfo.reviewed_date).toLocaleString()
              : '-'}
          </Typography>
        </DialogContent>
        <DialogActions>

          {isTeamUser &&
            reviewInfo.reviewed_by != null &&
            String(reviewInfo.reviewed_by) === String(userId) && (
              <Button onClick={handleRemoveReviewed} color="primary">
                Remove Review
              </Button>
            )}

          <Button onClick={() => setReviewInfoOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <FAQ open={openFAQ} setOpen={setOpenFAQ} />
      <MaterialTable
        tableRef={tableRef}
        title='Inquiries'
        icons={{
          Export: forwardRef((props, ref) =>
            <VerticalAlignBottomIcon color="primary" {...props} ref={ref} />
          ),
          ViewColumn: forwardRef((props, ref) =>
            <ViewColumnIcon color="primary" {...props} ref={ref} />
          ),
        }}
        columns={columns}
        data={data}
        options={{
          filtering: true,
          draggable: true,
          actionsColumnIndex: 0,
        }}
        onColumnDragged={handleColumnDragged}
        actions={[
          {
            icon: () => <ViewColumnIcon color="primary" />,
            tooltip: 'Show / Hide Columns',
            isFreeAction: true,
            onClick: (event) => setColumnMenuAnchor(event.currentTarget),
          },
          {
            icon: () => <VerticalAlignBottomIcon color="primary" />,
            tooltip: 'Export to CSV',
            isFreeAction: true,
            onClick: () =>
              ExportMaterialTable({
                tableRef,
                filename: 'inquiries',
              }),
          },
          {
            icon: () => <HelpIcon color='primary' />,
            tooltip: 'FAQ',
            isFreeAction: true,
            onClick: (event) => setOpenFAQ(true)
          },
          {
            icon: () => <RefreshIcon color='primary' />,
            tooltip: 'Refresh',
            isFreeAction: true,
            onClick: (event) => fetchData(!toggle)
          },
          {
            icon: () => <MonetizationOnIcon color='primary' />,
            tooltip: 'Place Bid',
            onClick: (event, rowData) => {
              setOpen(true);
              setBid({ ...bid, inquiry_id: rowData.inquiry_id });
            }
          },
          {
            icon: () => <MessageIcon color='primary' />,
            tooltip: 'Send Message',
            onClick: (event, rowData) => {
              setInquiryId(rowData.inquiry_id)
              setInquire(true)
            }
          },
          {
            icon: () => <InfoIcon color='primary' />,
            tooltip: 'More Info',
            onClick: (event, rowData) => {
              setInquiryId(rowData.inquiry_id)
              setOpenInfo(true)
            }
          },
        ]}
        components={{
          FilterRow: props => <CustomFilter {...props} />,
        }}
        detailPanel={accessModes}
        onRowClick={(event, rowData, togglePanel) => togglePanel()}
      />
      <AlertDialog
        open={inquire}
        setOpen={setInquire}
        title='Start Chat'
        content='Are you sure you wish to start a chat with the owner of this inquiry?'
        submitText='Submit'
        submit={submitInquiry}
      />
      <InfoDialog
        open={openInfo}
        onClose={handleCloseInfo}
        type='inquiry_info'
        id={inquiryId}
      />
      <Dialog
        maxWidth='md'
        fullWidth={true}
        open={open}
      >
        <DialogContent>
          <Grid container spacing={2} className={classes.place_bid}>
            <Typography>
              Place Bid
            </Typography>
            {/* <Tooltip title='Attach Files'>
              <IconButton
                onClick = {() => setBidAttach(true)}
                className = {classes.attach}
              >
                <AttachFileIcon color = 'primary'/>
              </IconButton>
            </Tooltip>
            <Grid item xs = {12}>
              {fileNames.length > 0 && fileNames.map((name, index) =>
                <Chip color='primary' key = {index} label={name} onDelete={() => chipDelete(index)}/>
              )}
            </Grid> */}
          </Grid>
          <InquiryBidForm
            bid={bid}
            updateField={updateField}
            setBid={setBid}
          />
          {/* <BidFileSelect
            open = {bidAttach}
            setOpen = {setBidAttach}
            type = 'inquiryBid'
            byteArrays = {byteArrays} setByteArrays = {setByteArrays}
            previewURLs = {previewURLs} setPreviewURLs = {setPreviewURLs}
            fileNames = {fileNames} setFileNames = {setFileNames}
            attach = {attach}
          /> */}
        </DialogContent>
        <DialogActions>
          <div className={classes.wrapper}>
            <Button onClick={handleSubmit} color="primary">
              Submit
            </Button>
            {loading &&
              <CircularProgress size={32} className={classes.loading} />
            }
          </div>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
